import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useEffect, useState } from "react";
import React from "react";
import { navItems, navLogeButton } from "../../../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faEllipsisVertical,
  faUserPlus,
  faUser,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import { theme, size } from "../../../../helpers/theme";
import { ReactComponent as LogeOutSvg } from "../../../../assets/icons/logout.svg";
import { ReactComponent as OrdersSvg } from "../../../../assets/icons/orders.svg";
import { ReactComponent as OrdersSvg_active } from "../../../../assets/icons/orders-active.svg";
import { ReactComponent as SmallLogo } from "../../../../assets/icons/logo-z-opisem.svg";
import { ReactComponent as SettingsSvg } from "../../../../assets/icons/settings.svg";
import { ReactComponent as SettingsSvg_active } from "../../../../assets/icons/settings-active.svg";
import { ReactComponent as AccountSvg } from "../../../../assets/icons/account.svg";
import { ReactComponent as AccountSvg_active } from "../../../../assets/icons/account-active.svg";
import { ReactComponent as HelpSvg } from "../../../../assets/icons/help.svg";
import { ReactComponent as HelpSvg_active } from "../../../../assets/icons/help-active.svg";
import { url } from "../../../../utils/url";
import { useAppDispatch } from "../../../../hooks/redux-hooks";
import SessionService from "../../../../services/session-service";
import { auth } from "../../../../redux/actions";
import {
  DivSideBarList2,
  DivSideBarList1,
  SideBarContainer,
  SideBarLogo,
  StyledBox,
  StyledListItem,
  StyledButton,
  StyledListItemTex,
} from "./styles";
import LogedUser from "./LogedUser";

interface SideBarMenuProps {
  isLoged: boolean;
  isMainMenuIsVisible: boolean;
  setVisibleMainLogo: (isVisibleMainLogo: boolean) => void;
  role: number | null;
}

type Anchor = "left";

export default function SideBarMenuComponent({
  isLoged,
  isMainMenuIsVisible,
  setVisibleMainLogo,
  role,
}: SideBarMenuProps) {
  const [state, setState] = useState({
    left: false,
  });

  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  let location = useLocation();

  const handleSubmitLogout = () => {
    SessionService.clearUserSession();
    SessionService.clearLoggedUserData();
    SessionService.clearOfferSubcontractorView();
    dispatch(auth.userLogout());
    navigate(url.login);
  };

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
      setVisibleMainLogo(open);
    };

  const list = (anchor: Anchor) => (
    <StyledBox
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      {" "}
      <DivSideBarList1>
        <SideBarLogo>
          <SmallLogo
            onClick={() => {
              navigate(`${url.homePage}`);
            }}
          />
        </SideBarLogo>

        {/* Główne Menu - użytkownik nie zalogowany oraz na stronach innych niż logowanie*/}
        {/* {(!isLoged && isMainMenuIsVisible) */}
        {isMainMenuIsVisible && !isLoged ? (
          <>
            <List>
              {navItems.map((text, index) => (
                <StyledListItem key={text.key} disablePadding>
                  <ListItemButton
                    disableRipple
                    onClick={() => {
                      navigate(`${text.url}`);
                    }}
                  >
                    <StyledListItemTex
                      primary={text.name}
                      sx={{
                        color:
                          text.url === location.pathname
                            ? `${theme.colors.black_primaryText}`
                            : `${theme.colors.gray01_secondaryText}`,
                      }}
                    />
                  </ListItemButton>
                </StyledListItem>
              ))}
            </List>
            <Divider />
          </>
        ) : (
          <></>
        )}

        {/* Menu użytkonika zalogowanego */}
        {isLoged ? <LogedUser role={role} isLoged={isLoged} /> : <></>}

        {/* Strefa logowania  dla użytkownika nie zalogowanego*/}
        {/* {(!isLoged && isMainMenuIsVisible) */}
        {!isLoged ? (
          <>
            <List>
              <StyledListItem disablePadding>
                <ListItemButton
                  disableRipple
                  onClick={() => {
                    navigate(`${navLogeButton[0].url}`);
                  }}
                >
                  <ListItemIcon>
                    {/* <AccountSvg /> */}
                    <FontAwesomeIcon icon={faUser as IconProp} />
                  </ListItemIcon>
                  <StyledListItemTex
                    primary={navLogeButton[0].name}
                    sx={{ color: `${theme.colors.gray01_secondaryText}` }}
                  />
                </ListItemButton>
              </StyledListItem>
            </List>
          </>
        ) : (
          <></>
        )}
      </DivSideBarList1>
      {/* Wyloguj się - tylko dla użytkownika zalogowanego*/}
      <DivSideBarList2>
        {isLoged ? (
          <>
            {" "}
            <List>
              <StyledListItem disablePadding>
                <ListItemButton disableRipple onClick={handleSubmitLogout}>
                  <ListItemIcon>
                    <LogeOutSvg />
                  </ListItemIcon>
                  <StyledListItemTex
                    primary={navLogeButton[1].name}
                    sx={{ color: `${theme.colors.gray01_secondaryText}` }}
                  />
                </ListItemButton>
              </StyledListItem>
            </List>
          </>
        ) : (
          <></>
        )}
      </DivSideBarList2>
    </StyledBox>
  );

  const winWidth = window.screen.width;

  const logedMenuMobileDetection = (anchor: Anchor) => {
    if (isLoged) {
      if (winWidth > 1024) {
        setVisibleMainLogo(true);
        return true;
      } else {
        return state[anchor];
      }
    } else {
      return state[anchor];
    }
  };

  const hideBackdrop = () => {
    if (isLoged) {
      if (winWidth > 1024) {
        return "permanent";
      } else {
        return "temporary";
      }
    } else {
      return "temporary";
    }
  };

  const hideButon = () => {
    if (isLoged) {
      if (winWidth > 1024) {
        return "none";
      } else {
        return "block";
      }
    } else {
      return "block";
    }
  };
  useEffect(() => {}, []);

  return (
    <SideBarContainer isLoged={isLoged}>
      {(["left"] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <StyledButton
            style={{ display: hideButon() }}
            disableRipple
            onClick={toggleDrawer(anchor, true)}
          >
            {/* <FontAwesomeIcon icon={faEllipsisVertical as IconProp}
                            size="2x"
                            style={{
                                backgroundColor: `${theme.colors.white}`,
                                padding: "5px 15px",
                                borderRadius: "20px",
                                position: "fixed",
                            }} /> */}

            <FontAwesomeIcon
              icon={faBars as IconProp}
              size="2x"
              style={{
                backgroundColor: `${theme.colors.gray04_background}`,
                color: `${theme.colors.blue01_active}`,
              }}
            />
          </StyledButton>

          <SwipeableDrawer
            anchor={anchor}
            open={logedMenuMobileDetection(anchor)}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
            // hideBackdrop={hideBackdrop()}
            variant={hideBackdrop()}
          >
            <div
              style={{
                backgroundColor: `${theme.colors.gray04_background}`,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                //justifyContent: "flex-end"
              }}
            >
              {list(anchor)}
            </div>
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </SideBarContainer>
  );
}
